import styled, { css } from 'styled-components';
import themeSpacing from 'styles/config/spacing';
import { radiusToStyle } from 'styles/utils';

import { SpacingStyles } from 'components/atoms/Spacing';
import type { StackStyledComponentProps } from './types';

export const Stack = styled.div<StackStyledComponentProps>`
  ${SpacingStyles};
  overflow: ${({ $overflow }) => $overflow};
  display: ${({ $display }) => $display};
  flex: ${({ $flex }) => $flex};
  gap: ${({ $spacing }) => themeSpacing[$spacing]};
  align-items: ${({ $align }) => $align};
  justify-content: ${({ $justify }) => $justify};

  ${({ $flow }) =>
    $flow !== undefined &&
    css`
      flex-flow: ${$flow};
    `}

  ${({ $direction }) =>
    $direction !== undefined &&
    css`
      flex-direction: ${$direction};
    `}

  ${({ $wrap }) =>
    $wrap !== undefined &&
    css`
      flex-wrap: ${$wrap};
    `}


  ${({ $width }) =>
    $width !== undefined &&
    css`
      width: ${typeof $width === 'number' ? `${$width}px` : $width};
    `}

  ${({ $height }) =>
    $height !== undefined &&
    css`
      height: ${typeof $height === 'number' ? `${$height}px` : $height};
    `}

  ${({ $maxWidth }) =>
    $maxWidth !== undefined &&
    css`
      max-width: ${typeof $maxWidth === 'number' ? `${$maxWidth}px` : $maxWidth};
    `}

  ${({ $maxHeight }) =>
    $maxHeight !== undefined &&
    css`
      max-height: ${typeof $maxHeight === 'number' ? `${$maxHeight}px` : $maxHeight};
    `}

  background-color: ${({ theme, $background }) =>
    $background ? theme.activeColorScheme.colors[$background] : 'transparent'};
  border-radius: ${({ theme, $radius }) => radiusToStyle(theme, $radius)};

  ${({ $borderColor }) =>
    $borderColor &&
    css`
      border-color: ${({ theme }) => theme.activeColorScheme.colors[$borderColor]};
    `}
  ${({ $borderWidth }) =>
    $borderWidth &&
    css`
      border-width: ${$borderWidth};
    `}
  ${({ $borderStyle, $borderColor, $borderWidth }) =>
    ($borderWidth || $borderColor) &&
    css`
      border-style: ${$borderStyle || 'solid'};
    `}

  ${({ $position }) =>
    $position &&
    css`
      position: ${$position};
    `};
`;
